import script from "./LayoutTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutTabs.vue?vue&type=script&setup=true&lang=js"

import "./LayoutTabs.vue?vue&type=style&index=0&id=105d7212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-105d7212"]])

export default __exports__